// import { createRouter } from "vue-router";
import VueSmoothScroll from "v-smooth-scroll";
import FloatingVue from "floating-vue"; // TODO: il existe déjà une version 3, il faut juste mettre à jour le package
import VueAwesomePaginate from "vue-awesome-paginate";

import vueClickOutside from "./modules/vueClickOutside";
import ToastPlugin from "./modules/toast";
import ModalPlugin from "./modules/modal";
import {
  moneyFilter,
  spaceNumber,
  copyToClipboard,
  openInNewTab,
  ucFirst,
  percentage,
  setAsideTop,
} from "./modules/utils";

import "./assets/styles/index.scss";

// Layouts
import Account from "./components/layouts/Account.vue";
import MainFooter from "./components/layouts/MainFooter.vue";
import MainHeader from "./components/layouts/MainHeader.vue";
import PageContent from "./components/layouts/PageContent.vue";

// Boutons
import ButtonClassic from "./components/buttons/ButtonClassic.vue";
import ButtonCheckbox from "./components/buttons/ButtonCheckbox.vue";
import ButtonService from "./components/buttons/ButtonService.vue";
import ButtonToggle from "./components/buttons/ButtonToggle.vue";
import ButtonGroup from "./components/buttons/ButtonGroup.vue";
import ButtonPopover from "./components/buttons/ButtonPopover.vue";

// Forms (select, input...)
import InputClassic from "./components/forms/InputClassic.vue";
import InputQuantity from "./components/forms/InputQuantity.vue";
import SelectClassic from "./components/forms/SelectClassic.vue";

// Infos (compteurs, toasts, notifications...)
import Counter from "./components/infos/Counter.vue";
import Notification from "./components/infos/Notification.vue";
import Toast from "./components/infos/Toast.vue";
import Tag from "./components/infos/Tag.vue";

// Progression, chargement...
import InfiniteLoader from "./components/progress/InfiniteLoader.vue";
import ProgressBar from "./components/progress/ProgressBar.vue";

// Modales
import Modal from "./components/modals/Modal.vue";
import ModalChangeImage from "./components/modals/ModalChangeImage.vue";

// Navigation
import Anchor from "./components/nav/Anchor.vue";
import AnchorsGroup from "./components/nav/AnchorsGroup.vue";
import TabsGroup from "./components/nav/TabsGroup.vue";
import Pagination from "./components/nav/Pagination.vue";
import PaginationBubble from "./components/nav/PaginationBubble.vue";
import NavigationMenu from "./components/nav/NavigationMenu.vue";

// Sliders
import Slider from "./components/sliders/Slider.vue";
import SliderCard from "./components/sliders/SliderCard.vue";

// En rapport avec le client
import LdeHelp from "./components/customers/LdeHelp.vue";
import Testimonials from "./components/customers/Testimonials.vue";

// Avatar
import Avatar from "./components/avatar/Avatar.vue";
import AvatarButton from "./components/avatar/AvatarButton.vue";

// Search
import SearchForm from "./components/search/SearchForm.vue";
import SearchFormSelect from "./components/search/SearchFormSelect.vue";

// Filters
import Filters from "./components/search/filters/Filters.vue";
import FilterSingle from "./components/search/filters/FilterSingle.vue";

// Icônes
import IconDownTriangle from "./components/icons/IconDownTriangle.vue";
import IconTrashReset from "./components/icons/IconTrashReset.vue";
import IconUserSquare from "./components/icons/IconUserSquare.vue";

import mixinFilterQuery from "./mixins/search/mixinFilterQuery";

const plugins = [
  // createRouter,
  VueSmoothScroll,
  vueClickOutside,
  ToastPlugin,
  ModalPlugin,
  // i18n,
];

export default {
  install(app) {
    plugins.forEach((plugin) => {
      if (typeof plugin === "function") {
        app.use(plugin());
      } else {
        app.use(plugin);
      }
    });

    // Pour les valeurs par défaut et leur signification, voir https://floating-vue.starpad.dev/guide/config
    app.use(FloatingVue, {
      themes: {
        tooltip: {
          popperTriggers: ["hover", "focus", "touch", "click"],
          placement: "top",
          disposeTimeout: 1000,
        },
        // Un nouveau thème rajoute une classe CSS dédiée (voir _tooltip.scss)
        blue: {
          $extend: "tooltip",
        },
      },
    });

    app.use(VueAwesomePaginate);

    // Permet d'utiliser i18n en l'appelant avec inject dans les default value des props
    if (app.config?.globalProperties?.$t) {
      app.provide("$t", app.config.globalProperties.$t);
    }
  },
};

export {
  // Composants
  Account,
  Anchor,
  AnchorsGroup,
  Avatar,
  AvatarButton,
  MainFooter,
  MainHeader,
  PageContent,
  ButtonClassic,
  ButtonCheckbox,
  ButtonService,
  ButtonToggle,
  ButtonGroup,
  ButtonPopover,
  Counter,
  Filters,
  FilterSingle,
  LdeHelp,
  InfiniteLoader,
  InputClassic,
  InputQuantity,
  Modal,
  ModalChangeImage,
  NavigationMenu,
  Notification,
  Pagination,
  PaginationBubble,
  ProgressBar,
  SearchForm,
  SearchFormSelect,
  SelectClassic,
  Slider,
  SliderCard,
  Tag,
  Testimonials,
  Toast,
  TabsGroup,

  // Icônes
  IconDownTriangle,
  IconTrashReset,
  IconUserSquare,

  // Mixins
  mixinFilterQuery,

  // Fonctions
  moneyFilter,
  spaceNumber,
  copyToClipboard,
  openInNewTab,
  ucFirst,
  percentage,
  setAsideTop,
};
